import React, { memo } from 'react';

export const withRole = (WrappedComponent, { managerOnly = false, fallback = null }) => {
  const WithRoleComponent = memo(({ isManager, isAuthenticated, ...props }) => {

    if (!isAuthenticated) {
      return null;
    }

    if (managerOnly && !isManager) {
      return fallback ? React.createElement(fallback, props) : null;
    }

    return <WrappedComponent {...props} />;
  });

  WithRoleComponent.displayName = `WithRole(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return WithRoleComponent;
};